import { OrderPolicy } from './order/OrderPolicy';
import { WeeklyEarningsPolicy } from './sales/WeeklyEarningsPolicy';
import { OrderManagementPolicy } from './order/OrderManagementPolicy';
import { UpcomingArrivalsPolicy } from './order/UpcomingArrivalsPolicy';
import { SchedulePolicy } from './schedule/SchedulePolicy';
import { ProspectPolicy } from './prospect/ProspectPolicy';
import { BackorderPolicy } from './backorder/BackorderPolicy';
import { PromissoryNotesPolicy } from './promissory_notes/PromissoryNotesPolicy';
import { DailySubdirectorPolicy } from './daily/DailySubdirectorPolicy';
import { VisorPolicy } from './visor/VisorPolicy';
import { customerExplorerPolicy } from './customer/CustomerExplorerPolicy';

const Policies = {
  OrderPolicy,
  WeeklyEarningsPolicy,
  OrderManagementPolicy,
  UpcomingArrivalsPolicy,
  SchedulePolicy,
  ProspectPolicy,
  BackorderPolicy,
  PromissoryNotesPolicy,
  DailySubdirectorPolicy,
  VisorPolicy,
  customerExplorerPolicy,
};

export default Policies;
